const KODIF_IFRAME_ID = 'kodif-chat-widget';
const KODIF_WIDGET_ORIGIN = 'https://chatwidget.kodif.ai';

export const openChat = () => {
  if (typeof window === 'undefined') return;
  try {
    const iframe = document.getElementById(KODIF_IFRAME_ID);
    iframe?.contentWindow?.postMessage(
      { type: 'toggle-expanded', isExpanded: true },
      KODIF_WIDGET_ORIGIN,
    );
  } catch (err) {
    console.error('Error opening Kodif widget:', err);
  }
};

// The widget iframe posts `{ type: 'kodif-widget-message', isExpanded, … }` to
// the parent every time it resizes itself, which is the only signal we get for
// whether the chat is open. Returns an unsubscribe function.
export const onChatExpandedChange = (callback) => {
  if (typeof window === 'undefined') return () => {};

  const handleMessage = (event) => {
    if (event.origin !== KODIF_WIDGET_ORIGIN) return;
    if (event.data?.type !== 'kodif-widget-message') return;
    callback(Boolean(event.data.isExpanded));
  };

  window.addEventListener('message', handleMessage);
  return () => window.removeEventListener('message', handleMessage);
};

export const openCall = (phone) => {
  if (typeof window !== 'undefined' && phone) {
    window.location.href = `tel:${phone}`;
  }
};
